import { actionTypes } from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: {},
}

const createCampaignByAgencyReducer = (state = initialState, action) => {
	switch (action.type) {
        case actionTypes.CREATE_CAMPAIGN_BY_AGENCY_REQUEST:
            return {
                ...state,
                loading: true,
            }
		case actionTypes.CREATE_CAMPAIGN_BY_AGENCY_SUCCESS:
			return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.CREATE_CAMPAIGN_BY_AGENCY_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.CREATE_CAMPAIGN_BY_AGENCY_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.CREATE_CAMPAIGN_BY_AGENCY_RESET_ALL:
            return initialState
		default:
			return state;
	}
};

export default createCampaignByAgencyReducer;
